import * as actionTypes from '../types/types';
var _ = require('lodash');

const initialState: any = {
  collaborator: [],
  filter: [],
  filter_assistant: [],
};

const AssistantReducer = (
  state = initialState,
  action: {type: string; payload: {employee_Nr: number}},
) => {
  switch (action.type) {
    case actionTypes.ADD_COLLABORATOR:
      return {...state, collaborator: [...state.collaborator, action.payload]};
    case actionTypes.SET_COLLABORATOR:
      return {...state, collaborator: action.payload};
    case actionTypes.SET_ALL_COLLABORATOR:
      var union = _.union([...state.collaborator], action.payload);
      var finalArray = _.uniqWith(union, _.isEqual);
      return {...state, collaborator: finalArray};
    case actionTypes.DELETE_COLLABORATOR:
      const filterCollaborator = state.collaborator.filter(
        (collaborator: {employee_Nr: number}) =>
          collaborator.employee_Nr !== action.payload.employee_Nr,
      );
      return {...state, collaborator: [...filterCollaborator]};
    case actionTypes.DELETE_ALL_COLLABORATOR:
      return {...state, collaborator: []};
    case actionTypes.SET_FILTER:
      return {...state, filter: action.payload};
    case actionTypes.SET_FILTER_ADD_ASSISTANT:
      return {...state, filter_assistant: action.payload};
    default:
      return state;
  }
};

export default AssistantReducer;
